import React, { Component } from "react";
import { LOGIN_ROUTE } from "./helper/Constants";
import { reactLocalStorage } from "reactjs-localstorage";

class Logout extends Component {

      componentDidMount() {
            var url = window.location.href;
            var arr = url.split("/");
            reactLocalStorage.clear();
            url = arr[0] + "//" + arr[2] + "/admin"+ LOGIN_ROUTE;
            window.location.href = url;
      }

      render() {
            return (
                  <React.Fragment>

                  </React.Fragment>
            )
      }
}

export default Logout;
